import { render, staticRenderFns } from "./cultureDetail.vue?vue&type=template&id=134848c6&scoped=true&"
import script from "./cultureDetail.vue?vue&type=script&lang=js&"
export * from "./cultureDetail.vue?vue&type=script&lang=js&"
import style0 from "./cultureDetail.vue?vue&type=style&index=0&id=134848c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134848c6",
  null
  
)

export default component.exports